import { PositionDetail } from "@/features/treasury/treasury";

export default function TreasuryLendingPositionPage() {
  return <PositionDetail />;
}
